<ng-container *ngIf="showToggle">
    <label class="toggle-mode">{{theme ? 'Bright Mode' : 'Dark Mode'}}</label>
    <label class="switch" [title]="theme ? 'Bright Mode' : 'Dark Mode'">
        <input type="checkbox" name="checkbox" [(ngModel)]="theme" (change)='changeTheme(); googleAnalyticChange()'>
        <span class="slider round"></span>
    </label>
</ng-container>